const Project = [
    {
        id: 1,
        image: "./images/emojigame.png", // Replace with real screenshot when available
        projectName: "JM - INVOICE",
        projectLink: "#",
        description: "A full-stack invoicing platform with secure JWT and Google OAuth authentication. Features PDF invoice generation, cloud-based logo uploads, and analytics dashboards.",
        techStack: ["React.js", "Node.js", "MongoDB", "JWT", "OAuth", "ApexCharts"]
    },
    {
        id: 2,
        image: "./images/todoapp.png", // Replace with real screenshot when available
        projectName: "Ecommerce Platform",
        projectLink: "#",
        description: "An eCommerce platform featuring role-based dashboards, product listing, order tracking, and inventory management with secure API integrations.",
        techStack: ["React.js", "Node.js", "Express.js", "MongoDB", "JWT"]
    },
    {
        id: 3,
        image: "./images/appstore.png",
        projectName: "App Store",
        projectLink:"https://my-app-store-eight.vercel.app/",
        description: "A responsive frontend application simulating an App Store interface.",
        techStack: ["React.js", "CSS3"]
    },
    {
        id: 4,
        image: "./images/sol.png",
        projectName: "Super Over League",
        projectLink:"https://venkatesh7975.github.io/super_over_league/",
        description: "A landing page design for a cricket league, showcasing responsive layout skills.",
        techStack: ["HTML5", "CSS3", "Bootstrap"]
    },
];

export default Project;